<script setup lang="ts">
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { STEP_ID } from '@/types'
import getEnv from '@/util/env.ts'
import { useBranchIOResolver } from '@/composables/api/use-branch-io.ts'
import { useDeviceIdentity } from '@/composables/use-device-identity.ts'
import { useIdentFlowState } from '@/composables/use-ident-flow-state.ts'
import { useRemoteLog } from '@/composables/use-remote-log.ts'

definePage({
  meta: {
    titleKey: 'tab.default',
  },
})

const route = useRoute()
const router = useRouter()
const { mergeFlowData } = useIdentFlowState()
const { ensureDeviceIdentity } = useDeviceIdentity()
const { getBranchData } = useBranchIOResolver()
const { sendLog } = useRemoteLog()

onMounted(async () => {
  const token =
    typeof route.query['token'] === 'string' ? route.query['token'] : ''

  // if a token param exists, it's a device handover case
  if (token) {
    mergeFlowData({ token })
  }

  await ensureDeviceIdentity()

  const branchIOId =
    typeof route.query['branch-io'] === 'string' ? route.query['branch-io'] : ''

  const branchIOUrl =
    typeof route.query['branch-io-url'] === 'string'
      ? route.query['branch-io-url']
      : ''

  if (branchIOId || branchIOUrl) {
    const url = branchIOUrl
      ? branchIOUrl
      : `${getEnv('VITE_BRANCH_IO_BASE_URL')}/${branchIOId}`

    sendLog({
      level: 'info',
      type: 'user-input',
      context: 'universal-link',
      message: 'Reacted to universal link',
      details: `Target URL: ${url}`,
    })

    const branchData = await getBranchData({ url })

    if (branchData.data && branchData.data['$voucherCode']) {
      mergeFlowData({ voucherCode: branchData.data['$voucherCode'] })
    } else {
      sendLog({
        level: 'warning',
        type: 'technical',
        context: 'universal-link',
        message: 'Universal link resolved without voucher code',
      })
    }
  }

  const stepId = token ? STEP_ID.HANDOVER_CONTINUE : STEP_ID.INTRO_DEEP_ID

  router.replace({
    name: 'flow',
    params: { stepId },
    query: {},
  })
})
</script>
